import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { getMeetingsUrl } from '../../../draft-transplant/utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
const MeetingPopoverEmptyState = () => /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
  image: "meetings",
  title: "hubspot-prosemirror.meetings.popover.zeroState.header",
  description: "hubspot-prosemirror.meetings.popover.zeroState.description",
  buttonLabel: "hubspot-prosemirror.meetings.popover.zeroState.button",
  buttonLink: getMeetingsUrl()
});
export default MeetingPopoverEmptyState;